import EventCalendar from "../components/EventCalendar";
import { FaRegUserCircle,FaRegCheckCircle, FaBirthdayCake } from "react-icons/fa";
import { IoCalendarOutline } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import { useContext, useEffect, useState } from "react";
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCookies } from "react-cookie";
import { GridLoader } from "react-spinners";
import {TopBar} from '../components/topbar';


export default function Home() {
    const navigate = useNavigate();
    const {userProfile, logOutFunction} = useContext(UserContext);
    const [cookies] = useCookies();
    const [dataList, setDataList] = useState([]);

    const [pageLoading, setPageLoading] = useState(true);

    useEffect(() => {
        getData();
    }, [])

    async function getData() {
        setPageLoading(true)
        try {
            const response = await axios.get(base_url + '/home.php', {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    memberno: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.code == 403) {
                logOutFunction()
            }
            if (response.data.status) {
                setDataList(response.data.data)
            } else {

            }
            setPageLoading(false)
        } catch (error) {
          setPageLoading(false)
        }
    }

    // const sections = [
    // {
    //     id: "001",
    //     name: "Tennis",
    //     fee: "₦50,000 / year",
    //     dueDate: "2025-12-31",
    // },
    // {
    //     id: "002",
    //     name: "Swimming",
    //     fee: "₦35,000 / year",
    //     dueDate: "2025-11-15",
    // },
    // {
    //     id: "003",
    //     name: "Golf",
    //     fee: "₦120,000 / year",
    //     dueDate: "2026-01-20",
    // },
    // {
    //     id: "004",
    //     name: "Cultural",
    //     fee: "₦20,000 / year",
    //     dueDate: "2025-09-30",
    // },
    // ]

  return (
    <div className="flex flex-col">
      {pageLoading && (
      <div className="flex items-center justify-center h-full w-[-webkit-fill-available] z-[99] bg-[#ffffff] fixed opacity-[0.9]">
        <GridLoader
            color={'#000080'}
            loading={true}
            size={20}
            aria-label="Loading Spinner"
            data-testid="loader"
        />
      </div>
      )}
        {/* <h2 className="text-2xl text-[#000080] font-bold mb-4">Welcome, {userProfile?.name}</h2> */}
        <TopBar title={`Blog Posts`} />
        <div className="px-6 grid md:grid-cols-3 gap-4 pb-6">
            {dataList?.map((post, index) => {
              return (
                <div className="bg-white rounded-2xl shadow-lg overflow-hidden max-w-md">
                  {/* Cover Image */}
                  <div className="h-48 w-full overflow-hidden">
                  <img
                  src={post.cover_img}
                  alt={post.title}
                  className="w-full h-full object-cover"
                  />
                  </div>


                  {/* Content */}
                  <div className="p-6 space-y-4">
                  <h2 className="text-xl font-bold text-gray-900 leading-snug">
                  {post.title}
                  </h2>


                  <p className="text-sm text-gray-500">
                  by <span className="font-medium">{post.author}</span> · {post.date} · {post.read_time} read
                  </p>


                  <a
                    href={post.link}
                    target="_blank"
                    className="inline-block bg-yellow-600 hover:bg-yellow-700 text-white font-semibold px-6 py-3 rounded-lg transition"
                  >
                    Read
                  </a>
                  </div>
                </div>
              )
            })}
        </div>
    </div>
  );
}
